"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "OverlayDrawerDialog", {
    enumerable: true,
    get: function() {
        return OverlayDrawerDialog;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _reactdialog = require("@fluentui/react-dialog");
// eslint-disable-next-line @typescript-eslint/naming-convention
const renderOverlayDrawerDialog_unstable = (state, contextValues)=>{
    const { content, trigger } = state;
    return /*#__PURE__*/ _react.createElement(_reactdialog.DialogProvider, {
        value: contextValues.dialog
    }, /*#__PURE__*/ _react.createElement(_reactdialog.DialogSurfaceProvider, {
        value: contextValues.dialogSurface
    }, trigger, content));
};
const OverlayDrawerDialog = /*#__PURE__*/ _react.memo((props)=>{
    const state = (0, _reactdialog.useDialog_unstable)(props);
    const contextValues = (0, _reactdialog.useDialogContextValues_unstable)(state);
    return renderOverlayDrawerDialog_unstable(state, contextValues);
});
OverlayDrawerDialog.displayName = 'OverlayDrawerDialog';
